{
  "nav": {
    "dashboard": "Dashboard",
    "articles": "Articles",
    "authors": "Authors",
    "media": "Media",
    "analytics": "Analytics",
    "settings": "Settings",
    "logout": "Log out"
  },
  "articles": {
    "title": "Articles",
    "newArticle": "New Article",
    "editArticle": "Edit Article",
    "drafts": "Drafts",
    "inReview": "In Review",
    "published": "Published",
    "archived": "Archived",
    "status": "Status",
    "category": "Category",
    "language": "Language",
    "author": "Author",
    "updated": "Updated",
    "actions": "Actions",
    "noArticles": "No articles yet",
    "deleteConfirm": "Are you sure you want to delete this article?"
  },
  "editor": {
    "step1": "Headline & Slug",
    "step2": "Body Content",
    "step3": "Media",
    "step4": "Badges & Metadata",
    "step5": "Access & Donation",
    "step6": "Review & Publish",
    "saveDraft": "Save Draft",
    "submitReview": "Submit for Review",
    "publish": "Publish",
    "archive": "Archive",
    "requestChanges": "Request Changes",
    "approve": "Approve",
    "step5AccessLabel": "Access level",
    "step5AccessDesc": "All articles are free and open to all readers in v1. Metered or subscriber-only content is not yet available.",
    "step5DonationLabel": "Reader support",
    "step5DonationDesc": "Readers support Beyond Silence through Buy Me a Coffee. A donation link appears at the end of every published article. No subscription or paywall is required."
  },
  "dashboard": {
    "title": "Dashboard",
    "publishedCount": "Published Articles",
    "totalViews": "Total Views",
    "totalDonations": "Total Donations",
    "avgReadTime": "Avg Read Time",
    "topArticles": "Top Articles",
    "topAuthors": "Top Authors",
    "dateRange": "Date Range",
    "filter": "Filter"
  }
}
